/**
 * Authentication configuration constants
 * These values must match the backend configuration
 */

/**
 * PBKDF2 salt for key derivation (hex string)
 * Used to derive user private keys from email and password
 */
export const PBKDF2_SALT = 'b187929a140646cb89be40c2523f31e1';

/**
 * PBKDF2 iteration count for key derivation
 * Higher values increase security but also computation time
 */
export const PBKDF2_ITERATIONS = 500000;

/**
 * Default session expiration time in seconds (1 hour)
 */
export const DEFAULT_SESSION_EXPIRATION = 3600;

/**
 * Extended session expiration time in seconds (7 days).
 * Matches the backend's per-session maximum
 * (b-cell-auth/validator/session/post.py).
 */
export const EXTENDED_SESSION_EXPIRATION = 7 * 24 * 3600;

